var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"slider",staticClass:"slider",style:(_vm.getStyle),attrs:{"type":"range","min":_vm.minValue,"max":_vm.maxValue},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }